import { Image, Text, type UseModalState } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { FullScreenDialog } from "@src/appV2/lib";
import sweaterImagePath from "@src/appV2/lib/assets/images/holiday-gift/sweater.png";
import Confetti from "react-confetti";

import { BottomSheetHeader } from "../components/BottomSheetHeader";
import { Button } from "../components/Button";
import { DialogFooter } from "../components/DialogFooter";
import { HolidayGiftShareScreen } from "./ShareScreen";

interface HolidayGiftBottomSheetProps {
  modalState: UseModalState;
  showConfetti: boolean;
  isSharing: boolean;
  onViewRedemptionInstructionsClick: () => void;
  handleShare: () => void;
}

export function HolidayGiftBottomSheet(props: HolidayGiftBottomSheetProps) {
  const { modalState, showConfetti, isSharing, onViewRedemptionInstructionsClick, handleShare } =
    props;

  return (
    <FullScreenDialog
      modalState={modalState}
      variant="tertiary"
      PaperProps={{
        sx: {
          background:
            "linear-gradient(180deg, rgba(251, 242, 232, 1) 0%, rgba(218, 241, 232, 1) 100%)",
          overflow: "hidden",
        },
      }}
    >
      <BottomSheetHeader
        onClose={() => {
          modalState.closeModal();
        }}
      />

      {showConfetti && (
        <Confetti
          width={window.innerWidth}
          height={window.innerHeight}
          numberOfPieces={400}
          gravity={0.8}
          recycle={false}
        />
      )}

      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack
          spacing={9}
          sx={{
            paddingTop: 10,
            paddingX: 5,
            textAlign: "center",
          }}
        >
          <Box paddingX={10}>
            <Image
              src={sweaterImagePath}
              alt="Free Sweater"
              borderRadius="25px"
              boxShadow="0 4px 4px 0 rgba(0, 0, 0, 0.25)"
              flex={1}
              width="100%"
            />
          </Box>

          <Text variant="h3" textAlign="center" px={4}>
            You earned a free jacket from FIGS!
          </Text>

          <Stack spacing={3}>
            <Text variant="h6" textAlign="center" color={(theme) => theme.palette.text.secondary}>
              You hit 1,000 Clipboard Score this year!
            </Text>

            <Text
              variant="body1"
              textAlign="center"
              color={(theme) => theme.palette.text.secondary}
            >
              This puts you in the top 1% of professionals. We&apos;re so grateful for all the work
              that you do.
            </Text>
          </Stack>
        </Stack>
      </Box>

      <DialogFooter orientation="vertical">
        <Button
          fullWidth
          disabled={isSharing}
          variant="contained"
          size="large"
          onClick={handleShare}
        >
          Share with friends
        </Button>
        <Button
          fullWidth
          variant="outlined"
          size="large"
          onClick={onViewRedemptionInstructionsClick}
        >
          View redemption instructions
        </Button>
      </DialogFooter>
      <Box
        sx={{ position: "absolute", top: "1000px", left: "1000px", width: "100%", height: "65%" }}
      >
        <HolidayGiftShareScreen />
      </Box>
    </FullScreenDialog>
  );
}
